(() => {
  const root = document.querySelector('[data-mg-wa]');
  if (!root || root.dataset.ready) return;
  root.dataset.ready = 'true';
  const details = root.querySelector('details');
  const choices = root.querySelector('[data-wa-choices]');
  let returnFocus = null;
  function message() {
    const productLink = document.querySelector('[data-mg-product] #whatsapp');
    if (productLink) {
      try { return new URL(productLink.href).searchParams.get('text') || root.dataset.hello; } catch {}
    }
    return root.dataset.hello;
  }
  function url(store) {
    const phone = root.dataset[store].replace(/\D/g, '');
    return 'https://wa.me/' + phone + '?text=' + encodeURIComponent(message());
  }
  function refresh() {
    root.querySelectorAll('[data-wa-branch]').forEach(a => { a.href = url(a.dataset.waBranch); });
  }
  function close() {
    details.open = false;
    (returnFocus?.isConnected ? returnFocus : root.querySelector('summary')).focus();
    returnFocus = null;
  }
  root.addEventListener('click', e => {
    const pick = e.target.closest('[data-wa-branch]');
    if (pick) {
      pick.href = url(pick.dataset.waBranch);
      // Preserve the native link action; only close the panel after the click.
      queueMicrotask(() => { details.open = false; });
    }
    if (e.target.closest('[data-wa-close]')) close();
  });
  details.addEventListener('toggle', () => { if (details.open) refresh(); });
  document.addEventListener('keydown', e => { if (e.key === 'Escape' && details.open) { e.preventDefault(); close(); } });
  document.addEventListener('click', e => {
    const link = e.target.closest('[data-mg-product] #whatsapp');
    if (link) {
      e.preventDefault(); returnFocus = link; refresh(); details.open = true; choices.querySelector('a').focus();
    } else if (details.open && !root.contains(e.target)) details.open = false;
  });
  const tray = document.querySelector('.mg-compare-tray');
  if (tray) {
    const measure = () => root.style.setProperty('--mg-wa-tray', tray.hidden ? '0px' : tray.getBoundingClientRect().height + 'px');
    new ResizeObserver(measure).observe(tray);
    new MutationObserver(measure).observe(tray, {attributes:true, attributeFilter:['hidden']});
    measure();
  }
  refresh();
})();
